var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex p-5 w-full"},[_c('meeting-form2',{staticClass:"flex w-full",attrs:{"show-required":false,"show-type":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }